import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import styles from './Screenlock.module.scss';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import cn from 'classnames';
export const Screenlock = ({ isLocked }) => {
    const darkMode = useSelector((state) => state.settings.darkMode);
    if (!isLocked) {
        return _jsx(_Fragment, {});
    }
    else {
        //Normally you dont have to have the component overriden like this.  But for some reason their is a conflict with one of the other
        //packages we are using.
        return (_jsx(Box, Object.assign({ component: "div", className: styles.screenlock }, { children: _jsx(Box, { component: "div", className: cn(styles.loader, darkMode && styles.isDarkMode) }) })));
    }
};
